import { isProduction } from '../modules/app/config'
import { useMemo } from 'react'
import { getChainId, Network, SpritzPaySDK, SpritzPayV3SDK } from '@spritz-finance/sdk'
import { useWeb3Connection } from '../web3/Web3Provider'
import { RPC_PROVIDERS } from '../web3/connection/providers'
import { useDirectPayContext } from '../modules/bills/components/directPay/context/DirectPayContext'

const shouldUseV3Sdk = (network: Network, staging: boolean, sdkConfig: string[]): boolean => {
    const envString = staging ? 'staging' : 'production'
    return sdkConfig.includes(`${network}:${envString}`)
}

export const useSpritzPaySDK = (): SpritzPaySDK | SpritzPayV3SDK => {
    const { sdkConfig } = useDirectPayContext()
    const { connectedNetwork } = useWeb3Connection()
    if (!connectedNetwork) throw new Error('Not connected to supported network')
    const staging = !isProduction()

    const SDK = shouldUseV3Sdk(connectedNetwork, staging, sdkConfig) ? SpritzPayV3SDK : SpritzPaySDK

    const spritzSdk = useMemo(() => {
        return new SDK({
            network: connectedNetwork,
            provider: RPC_PROVIDERS[getChainId(connectedNetwork)],
            staging,
        })
    }, [SDK, connectedNetwork, staging])

    return spritzSdk
}
